import React, { Component } from 'react';
import './home.scss';
import $ from 'jquery';
import Typing from 'react-typing-animation';
import {
  Card,
  CardTitle,
  CardDeck,
  CardSubtitle,
  CardBody
} from 'reactstrap';
import InfoCard from '../../components/info-card/info-card';
import Slider from 'react-slick';
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';

var settings = {
  autoplay: true,
  dots: true,
  autoplaySpeed: 10000,
  infinite: true,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  className: "slider"
};

class Home extends Component {
  constructor(props) {
    super(props);

    this.animatedCounter = false;
    this.onVisibilityChange = this.onVisibilityChange.bind(this);
    this.windowScroll = this.windowScroll.bind(this);
    this.transparentNav = this.transparentNav.bind(this);
    this.standardNav = this.standardNav.bind(this);
  }

  transparentNav() {
    $('.nav-header').addClass('transparent-navbar');
    $('.nav-header').removeClass('bb-navbar');
    $('.logo-img').attr('src', require('../../assets/bb-logo-white.png'));
  }

  standardNav() {
    $('.nav-header').addClass('bb-navbar');
    $('.nav-header').removeClass('transparent-navbar');
    $('.logo-img').attr('src', require('../../assets/bb-logo.png'));
  }

  windowScroll() {
    var path = window.location.pathname;
    var scroll = $(window).scrollTop();
    if (path === "/") {
      if (scroll > 200 || window.innerWidth <= 770) {
        this.standardNav();
      }
      else {
        this.transparentNav();
      }

      // Allow counting animation to run again if scrolled below 600
      if (scroll < 600) {
        this.animatedCounter = false;
      }
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    if (window.innerWidth > 700) {
      this.transparentNav();
    }
    window.addEventListener('scroll', this.windowScroll);
  }

  componentWillUnmount() {
    this.standardNav();
  }

  componentDidCatch(error, info) {
    console.log(error);
    console.log(info);
  }

  onVisibilityChange(isVisible) {
    if (isVisible && this.animatedCounter === false) {
      this.animatedCounter = true;
      this.teamCounter.restart();
      this.projectCounter.restart();
      this.linesCounter.restart();
    }
  }

  render() {
    return (
      <div className="home">
        <div className="header">
          <div className="header-center-container">
            <div>
              <h1 className="title" data-aos="zoom-in-up" data-aos-duration="1000">BIT BENDERS</h1>
              <div className="sub-title" data-aos="fade-up" data-aos-delay="1000" data-aos-duration="1000">
                <div>
                  We are the best in
                </div>
                <div>&nbsp;</div>
                <Typing>
                  <Typing.Speed ms={0} />
                  Web Development
                  <Typing.Speed ms={50} />
                  <Typing.Backspace count={15} delay={3000} />
                  Mobile Development
                  <Typing.Backspace count={18} delay={2000} />
                  Web Hosting
                  <Typing.Backspace count={11} delay={2000} />
                  <span className="bold-sub">All Things Technology</span>
                  <Typing.Delay ms={10000000000} />
                </Typing>
              </div>
            </div>
          </div>
          <div className="header-bottom-container">
            <div className="bottom-container">
              {/*<Link to="main-content">
                <i className="fas fa-chevron-circle-down enter-site-button"></i>
              </Link>
              */}
            </div>
          </div>
        </div>
        <div id="main-content" className="main">
          <div>
            <h1 className="title">We work with you to make your vision become reality</h1>
            <h5 className="subtitle">
              Our experts meet with you to discuss your application's needs.
              We take the time to come up with the perfect solution that works for your budget and to develop a world class application.
              We build products that are long lasting in a world where technology is rapidly changing.
            </h5>
          </div>
          <div className="design-develop-deploy">
            <CardDeck>
              <Card>
                <span className="icon-holder"><i className="fas fa-th icon"></i></span>
                <CardBody>
                  <div>
                    <CardTitle>Design</CardTitle>
                    <CardSubtitle>Our team of designers create the perfect prototype</CardSubtitle>
                  </div>
                </CardBody>
              </Card>
              <Card>
                <span className="icon-holder"><i className="fas fa-code icon"></i></span>
                <CardBody>
                  <div>
                    <CardTitle>Develop</CardTitle>
                    <CardSubtitle>Our developers take the prototype and make it come to life</CardSubtitle>
                  </div>
                </CardBody>
              </Card>
              <Card>
                <span className="icon-holder"><i className="fas fa-cloud icon"></i></span>
                <CardBody>
                  <div>
                    <CardTitle>Deploy</CardTitle>
                    <CardSubtitle>We deploy your website to a secure, dedicated server</CardSubtitle>
                  </div>
                </CardBody>
              </Card>
            </CardDeck>
          </div>
          <hr/>
          <div className="services">
            <div>
              <h1 className="title">Our Services</h1>
              <h5 className="subtitle">
                We offer a one stop shop for all your development needs.
                Because we are experts in all things technology, we can design, develop, and deploy unique applications that work for you and your company.
              </h5>
            </div>
            <div className="card-wrapper">
              <InfoCard
                backgroundColor="white"
                fontAwesomeClass="fas fa-mobile"
                cardTitle="Mobile Development"
                iconcolor="#3d3d3d"
                cardText="We are experts in mobile app development and are able to share code between platforms to save time and cost."
              />
              <InfoCard
                backgroundColor="white"
                fontAwesomeClass="fas fa-globe"
                cardTitle="Web Development"
                iconcolor="#00a8fc"
                cardText="We utilize the newest frameworks like React and Django to develop world class web applications that last."
              />
              <InfoCard
                backgroundColor="white"
                fontAwesomeClass="fas fa-server"
                cardTitle="Web Hosting"
                iconcolor="#49d1b1"
                cardText="Our presence in AWS and Azure allows us to deploy a dedicated server enviornment tailored for your application."
              />
              <InfoCard
                backgroundColor="white"
                fontAwesomeClass="fas fa-wrench"
                cardTitle="Managed Services"
                iconcolor="#999999"
                cardText="Need support for your infrustucture? We can do that too! We keep up with the latest and greatest trends to give you the best support."
              />
            </div>
          </div>
          <VisibilitySensor onChange={this.onVisibilityChange} delayedCall >
            <div className="sensor"></div>
          </VisibilitySensor>
          <div className="counter-section">
            <div className="wrapper">
              <div className="counter-block">
                <div>
                  <div className="center">
                    <CountUp className="counter" start={0} end={10} duration={3} ref={countUp => {this.teamCounter = countUp;}}/>
                  </div>
                  <p className="counter-subtext">Team Members</p>
                </div>
              </div>
              <div className="counter-block">
                <div>
                  <div className="center">
                    <CountUp className="counter" start={0} end={18} duration={3} ref={countUp => {this.projectCounter = countUp;}}/>
                  </div>
                  <p className="counter-subtext">Finished Projects</p>
                </div>
              </div>
              <div className="counter-block">
                <div>
                  <div className="center">
                    <CountUp className="counter" start={0} end={34657} suffix="+" duration={3} ref={countUp => {this.linesCounter = countUp;}} />
                  </div>
                  <p className="counter-subtext">Lines of Code</p>
                </div>
              </div>
            </div>
          </div>
          <div className="customer-testimonials">
            <h1 className="title">Customer Testimonials</h1>
            <div className="carousel-wrapper">
              <Slider {...settings}>
                <div className="slider-content">
                  <div>
                    <p className="review">"These guys are the real deal! Trust Bit Benders with anything you need. They are also extremely patient. I have been going through one of the worst years of my life while also trying to start up a website, and they have been there for me and have been as patient as possible. I really appreciate everything they have done for me and I recommend them to anyone."</p>
                    <p className="review">-Cappersunite</p>
                    <i className="fas fa-star review-star"></i>
                    <i className="fas fa-star review-star"></i>
                    <i className="fas fa-star review-star"></i>
                    <i className="fas fa-star review-star"></i>
                    <i className="fas fa-star review-star"></i>
                  </div>
                </div>
                <div className="slider-content">
                  <div>
                    <p className="review">"Very quick turn around time! Bit Benders had a prototype build within a few days and had it deployed after two weeks! They have a fantastic group of developers!"</p>
                    <p className="review">-Miner National Services</p>
                    <i className="fas fa-star review-star"></i>
                    <i className="fas fa-star review-star"></i>
                    <i className="fas fa-star review-star"></i>
                    <i className="fas fa-star review-star"></i>
                    <i className="fas fa-star review-star"></i>
                  </div>
                </div>
                <div className="slider-content">
                  <div>
                    <p className="review">"Responsive and friendly! They'll send mock-ups and designs for approval as well as patiently make changes. Thanks!"</p>
                    <p className="review">-Class Valet</p>
                    <i className="fas fa-star review-star"></i>
                    <i className="fas fa-star review-star"></i>
                    <i className="fas fa-star review-star"></i>
                    <i className="fas fa-star review-star"></i>
                    <i className="fas fa-star review-star"></i>
                  </div>
                </div>
                <div className="slider-content">
                  <div>
                    <p className="review">"Bit Benders was able to build our app meeting all expectations. As we needed updates and new features added to the app they were always able to quickly deliver!"</p>
                    <p className="review">-Total Fleet Solutions</p>
                    <i className="fas fa-star review-star"></i>
                    <i className="fas fa-star review-star"></i>
                    <i className="fas fa-star review-star"></i>
                    <i className="fas fa-star review-star"></i>
                    <i className="fas fa-star review-star"></i>
                  </div>
                </div>
              </Slider>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/pages/home/home.js